import RenderIf from "@/components/render-if";

const QuestionCard = ({question, selectedAnswer, onAnswerSelect, questionNumber}) => {
    const options = [
        {key: 'opt1', value: question?.opt1},
        {key: 'opt2', value: question?.opt2},
        {key: 'opt3', value: question?.opt3},
        {key: 'opt4', value: question?.opt4},
    ];

    return (
        <div className="space-y-6">
            <div className="bg-gradient-to-l from-blue-50 to-cyan-50 dark:from-slate-800 dark:to-slate-800/80 rounded-2xl p-6 border-2 border-blue-100 dark:border-slate-700">
                <div className="flex items-start gap-4">
                    <div
                        className="flex-shrink-0 w-10 h-10 bg-blue-600 dark:bg-blue-500 text-white rounded-full flex items-center justify-center font-bold text-lg">
                        {questionNumber}
                    </div>
                    <h2 className="text-xl font-bold leading-relaxed pt-1 text-gray-900 dark:text-gray-100">
                        {question?.title}
                    </h2>
                </div>
            </div>

            <div className="space-y-3">
                {options.map((option, index) => (
                    <RenderIf key={option.key} condition={option.value}>
                        <button
                            onClick={() => onAnswerSelect(option.key)}
                            className={`w-full text-right p-5 rounded-xl border-2 transition-all duration-300 group ${
                                selectedAnswer === option.key
                                    ? 'bg-blue-600 dark:bg-blue-500 border-blue-600 dark:border-blue-500 text-white shadow-lg scale-[1.02]'
                                    : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 text-gray-800 dark:text-gray-200 hover:border-blue-400 dark:hover:border-blue-500 hover:bg-blue-50 dark:hover:bg-slate-700 hover:scale-[1.01]'
                            }`}
                        >
                            <div className="flex items-center gap-4">
                                <div
                                    className={`flex-shrink-0 w-8 h-8 rounded-full border-2 flex items-center justify-center font-bold transition-all ${
                                        selectedAnswer === option.key
                                            ? 'bg-white text-blue-600 border-white'
                                            : 'border-gray-300 dark:border-slate-600 text-gray-400 dark:text-gray-400 group-hover:border-blue-400 dark:group-hover:border-blue-500 group-hover:text-blue-600 dark:group-hover:text-blue-400'
                                    }`}
                                >
                                    {index + 1}
                                </div>
                                <span className="text-lg font-medium">{option.value}</span>
                            </div>
                        </button>
                    </RenderIf>
                ))}
            </div>
        </div>
    );
};

export default QuestionCard;